import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';
import classNames from 'classnames';

import {
  DELETE_CLASS_MODAL_STAGES,
  deleteSbatGroupCommunicationsSelector,
  deleteReasonSelector,
  resetDeleteModal,
  selectedDeleteSbatGroupSelector,
  setDeleteClassModalStage,
  useDeleteSbatGroupMutation,
  VIEW_SCHEDULE_PAGE_TRACKINGS,
} from 'features/classCreation';
import analytics from 'utils/analytics';
import styles from './DeleteClassModalConfirmationStage.module.scss';

export default function DeleteClassModalConfirmationStage() {
  const dispatch = useDispatch();
  const selectedSbatGroup = useSelector(selectedDeleteSbatGroupSelector);
  const communications = useSelector(deleteSbatGroupCommunicationsSelector);
  const deleteReason = useSelector(deleteReasonSelector);
  const [deleteSbatGroup, { isSuccess, error, isLoading }] =
    useDeleteSbatGroupMutation();

  const handleCancel = useCallback(() => {
    dispatch(setDeleteClassModalStage(DELETE_CLASS_MODAL_STAGES.reason));
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Class is successfully cancelled!');
      dispatch(resetDeleteModal());
    }
    if (error) {
      cogoToast.error(
        error?.data?.message ||
          'There was some problem in cancelling the class. Please try again later!'
      );
    }
  }, [dispatch, error, isSuccess]);

  const handleConfirm = useCallback(() => {
    const comms = Object.keys(communications).filter(
      (key) => communications[key]
    );

    analytics.click({
      click_type: VIEW_SCHEDULE_PAGE_TRACKINGS.deleteClass,
      custom: {
        class_id: selectedSbatGroup.id,
        comms,
        reason: deleteReason?.label,
      },
    });

    deleteSbatGroup({
      sbatGroupId: selectedSbatGroup.id,
      comms,
      reason: deleteReason?.label,
    });
  }, [
    communications,
    deleteReason?.label,
    deleteSbatGroup,
    selectedSbatGroup.id,
  ]);

  return (
    <div className="column justify-c align-c">
      <div className="m-b-m dark h4">
        Are you sure you want to cancel the selected class?
      </div>
      <Tappable
        onClick={handleConfirm}
        disabled={isLoading}
        className={classNames(
          styles.button,
          'btn btn-primary btn-long h4 m-b-xs'
        )}
      >
        Yes, I’d like to proceed
      </Tappable>
      <Tappable
        onClick={handleCancel}
        disabled={isLoading}
        className={classNames(
          styles.button,
          'btn btn-primary btn-outlined btn-long h4'
        )}
      >
        No, I clicked on it by mistake
      </Tappable>
    </div>
  );
}
